<template>
  <div>
    <h3 class="title-page">{{ $t("team") }}: {{ formTitle }}</h3>
    <div class="admin_container">
      <back-btn />
      <v-row justify="center">
        <v-col md="8" cols="12">
          <v-card-title class="px-0">{{ formTitle }}</v-card-title>
          <validation-observer v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(save)">
              <div class="mb-4">
                <custom-input-text
                  rules="required"
                  :label="$t('name')"
                  class="user_input no-margin"
                  v-model="teamData.name"
                />
              </div>
              <div class="mb-3">
                <vue-select
                  rules="required"
                  multiple
                  infinite
                  @next-page-resolved="
                    (data) => setDepartment([...departments, ...data])
                  "
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getDepartments', {
                        name: text,
                        page,
                        limit: 15,
                      })
                  "
                  :items="departments"
                  :label="$t('department')"
                  class="user_input no-margin"
                  v-model="teamData.departments"
                />
              </div>
              <div class="mb-3">
                <vue-select
                  rules="required"
                  infinite
                  @next-page-resolved="
                    (data) => setTeamLeader([...teamLeaders, ...data])
                  "
                  :get-item-promise="
                    ({ text, page }) =>
                      $store.dispatch('getDepartments', {
                        name: text,
                        page,
                        limit: 15,
                      })
                  "
                  :items="teamLeaders"
                  :label="$t('teamLeader')"
                  class="user_input no-margin"
                  v-model="teamData.teamLeader"
                />
              </div>
              <div class="text-right">
                <v-btn type="submit" color="primary">{{ $t("save") }}</v-btn>
              </div>
            </form>
          </validation-observer>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import VueSelect from "@/components/ui/vue-select/VueSelect";
import BackBtn from "@/components/ui/BackBtn";

export default {
  components: { BackBtn, VueSelect },
  props: ["id"],
  data() {
    return {
      teamData: {
        name: null,
        departments: [],
        teamLeader: null,
      },
      departments: [],
      teamLeaders: [],
    };
  },
  computed: {
    isUpdate() {
      return !!this.id;
    },
    formTitle() {
      return this.isUpdate ? this.$t("editGroup") : this.$t("create");
    },
  },
  methods: {
    setTeamLeader(teamLeaders) {
      this.teamLeaders = teamLeaders;
    },
    setDepartment(departments) {
      this.departments = departments;
    },
    async getItemData() {
      try {
        const {
          data: {
            /**
             * @type Object
             * @property teamLeaderId
             * @property teamLeaderName
             */ data,
          },
        } = await this.$http.get(`teams/get?id=${this.id}`);
        this.departments = data.departments.map((item) => {
          return item;
        });
        data.departments = data.departments.map((item) => {
          return item.id;
        });
        data.teamLeader = data.teamLeaderId;
        this.teamLeaders = [
          {
            id: data.teamLeaderId,
            name: data.teamLeaderName,
          },
        ];
        this.teamData = data;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async save() {
      this.showLoading();
      try {
        const data = { ...this.teamData };
        if (this.isUpdate) data.id = this.id;
        await this.$http.post("teams", data);
        await this.$router.push({ name: "team-index" });
        this.setSuccess({ text: this.$t("successfullySaved") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  async created() {
    this.showLoading();
    if (this.isUpdate) {
      await this.getItemData();
    }
    this.clearLoading();
  },
};
</script>
